<template>
  <v-card class="user-history" tile>
    <v-card-title>{{ this.$t('statistics.workProcess') }}</v-card-title>
    <div class="pa-2 pl-4">
      <dl v-if="type" class="form-box">
        <dt class="d-table-cell pt-1">{{ this.$t('statistics.target') }}</dt>
        <dd class="d-table-cell sts-form-radio-mgt-0">
          <v-radio-group v-model="vms.wpType" row dense hide-details>
            <v-radio :label="item.text" :value="item.value" v-for="(item, index) in type" :key="index"></v-radio>
          </v-radio-group>
        </dd>
      </dl>
    </div>
  </v-card>
</template>

<script>
export default {
  components: {},
  props: {
    type: Array,
  },
  data() {
    return {
      vms: {
        wpType: null,
      },
    };
  },
  watch: {
    vms: {
      handler(val) {
        this.$emit('changeWorkprcsLoad', val, 'workprcsLoad');
      },
      deep: true,
    },
  },
  computed: {},
  created() {
    this.initDefaultValue();
  },
  methods: {
    initDefaultValue() {
      this.vms = {
        wpType: this.type[0].value,
      };
    },
  },
};
</script>
